import React, { useMemo, useState } from 'react';
import EnvelopeMantyStatusHypothesesChangesContext from './EnvelopeMantyStatusHypothesesChangesContext';
import { useGetNonRecurrentHypothesisTypePerMantyStatus } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/HypothesisTypePerMantyStatus/helpers/hooks/nonRecurrentHypothesisTypePerMantyStatus';
import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { camelize } from 'helpers/syntaxHelper';

type Props = {
    children?: React.ReactNode;
    hrSimulationId: number;
};

const EnvelopeMantyStatusHypothesesChangesContextProvider = ({
    children = <></>,
    hrSimulationId,
}: Props): React.ReactElement => {
    const [hasChanges, setHasChanges] = useState(false);
    const { data: hypothesisTypePerMantyStatus } =
        useGetNonRecurrentHypothesisTypePerMantyStatus(hrSimulationId);
    const nonRecurrentStatuses = useMemo(
        () =>
            (hypothesisTypePerMantyStatus &&
                Object.keys(hypothesisTypePerMantyStatus).filter(
                    (key) => hypothesisTypePerMantyStatus[key] === 'envelope',
                )) ||
            [],
        [hypothesisTypePerMantyStatus],
    );
    return (
        <EnvelopeMantyStatusHypothesesChangesContext.Provider
            value={{
                hasChanges,
                setHasChanges,
                nonRecurrentEnvelopeStatuses: Object.values(MantyStatus).filter(
                    (status) => nonRecurrentStatuses.includes(camelize(status)),
                ) as MantyStatus[],
            }}
        >
            {children}
        </EnvelopeMantyStatusHypothesesChangesContext.Provider>
    );
};

export default EnvelopeMantyStatusHypothesesChangesContextProvider;
